import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Redirect, useHistory, useLocation } from 'react-router';


interface IAdminUsersContext {
    isLoading: boolean
    users: IUser[]
    search: ISearch
    recordCount: number

    deleteUser: (id: string) => Promise<void>
    doSearch: () => void
    changePage: (event: any, page: number) => void
    updateSearch: (newSearch: ISearch) => void
}

interface IUser {
    id: string
    email: string
    name: string
    userType: string
    countryCode: string
    company: string
    existOnCognito: boolean
}

interface ISearch {
    pageNr: number
    pageSize: number
    name: string
    userType: string
    countryCode: string
}

export let adminUsersContext = React.createContext({} as IAdminUsersContext);

let { Provider } = adminUsersContext;

let AdminUsersProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    let location = useLocation();
    let history = useHistory();

    let [isLoading, setLoading] = useState(false);
    let [recordCount, setRecordCount] = useState(0);
    let [users, setUsers] = useState<IUser[]>([]);

    let [search, setSearch] = useState<ISearch>({
        countryCode: '',
        name: '',
        pageNr: 0,
        pageSize: 15,
        userType: ''
    });

    useEffect(() => {
        if (location.state)
            processState(location.state);
    }, [location.state])

    if (!location.state)
        return <Redirect to={{ pathname: location.pathname, state: { search } }} />


    let processState = (state: any) => {
        if (state.search) {
            setSearch({
                ...search,
                ...state.search
            })
        }

        getUsers({
            ...search,
            ...state.search
        });
    }

    let getUsers = async (request: ISearch) => {
        try {
            setLoading(true);
            let res = await axios.get('/api/AdminUser/GetAdminUsers', { params: request });
            setUsers(res.data.items);
            setRecordCount(res.data.recordCount);

        } catch (err) { }
        finally {
            setLoading(false);
        }
    }

    let deleteUser = async (id: string) => {
        if (window.confirm("Are you sure that you want to delete this user?")) {
            try {
                await axios.delete(`/api/AdminUser/DeleteAdminUser/${id}`);
                setUsers(users.filter(x => x.id !== id));
                setRecordCount(recordCount - 1);
            } catch (err) { }
        }
    }

    let updateSearch = (newSearch: ISearch) => {
        setSearch(newSearch);
    }

    let changePage = (event: any, page: number) => {
        let request = {
            ...search,
            pageNr: page
        }

        window.scrollTo(0, 0);
        history.push(location.pathname, { search: request });
    }

    let doSearch = () => {
        let request = {
            ...search,
            pageNr: search.pageNr > 0 ? 0 : search.pageNr
        }

        history.push(location.pathname, { search: request });
    }


    return (
        <Provider
            value={{
                isLoading,
                users,
                search,
                recordCount,

                deleteUser,
                changePage,
                doSearch,
                updateSearch
            }}
        >{children}</Provider>
    )
}

export default AdminUsersProvider;